import React, { PureComponent } from 'react';
import Table from 'rc-table';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

function mapCreditCard(creditCard, orden) {
    
    let nombre = creditCard.Nombre ? <label><i>{creditCard.Nombre}</i></label> : <label>{creditCard.ClienteNombre + " " + creditCard.ClienteApellido}</label>;       
    let tarjetaLimite = (GlobalHelper.ParseFloat(creditCard.Limite, 10) || GlobalHelper.ParseFloat(creditCard.PorcentajeLimiteCompra, 10));
    let limiteText = tarjetaLimite >= 0 ? tarjetaLimite + "% (" + GlobalHelper.ConvertirNumeroMilesMillones(creditCard.Valor) + ")" : "SIN LÍMITE";    

    return {
        id: creditCard.Id,
        tipo: creditCard.Tipo ? creditCard.Tipo : creditCard.TarjetaTipoDescripcion,
        limite: limiteText,
        orden: orden + 1,
        tipo: creditCard.Tipo,
        nombre: nombre,
        tipoDescripcion: creditCard.TarjetaTipoDescripcion
    };

}

const TableRowItalic = ({ id, text, altText }) => {

    if (id > 0)
        return <label className="td-bold td-bold-black">{text}</label>;

    return <label className="td-bold td-bold-black"><i>{altText}</i></label>;

}

const RequestedCardsTable = ({ creditCards }) =>
{

    const mappedCreditCards = creditCards.map((c, index) => mapCreditCard(c, index));

    const columns = [
    {
       title: <label>Nº</label>, dataIndex: 'orden', key: 'orden', width: 100, render: (text, row) => <TableRowItalic id={row.id} text={text} altText={text} />,
    },
    {
        title: <label>NOMBRE</label>, dataIndex: 'nombre', key: 'nombre', width: 100,
    },
    {
       title: <label>TIPO</label>, dataIndex: 'tipo', key: 'tipo', width: 200, render: (text, row) => row.tipo ? <label><i>{row.tipo}</i></label> : <label><i>{row.tipoDescripcion}</i></label> 
    },
    {
        title: <label>LIMITE</label>, dataIndex: 'limite', key: 'limite', render: (text, row) => row.id > 0 ? <label>{row.limite}</label> : <label><i>{row.limite}</i></label>,
    }];


    return <Table columns={columns} data={mappedCreditCards} className="table table-striped" />;

}


export default RequestedCardsTable;